import WorkerApiService from "../../workerApiServices"

class PedidoCompraService extends WorkerApiService {

    constructor() {
        super('/api/pedidoCompra')
    }

    search(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/search${params}`)
    }

    searchIntegracao(){
        return this.get(`/searchIntegracao`)
    }

    importar(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/importar${params}`)
    }

    viewItens(id){
        let params = `?`
        params = `${params}&id=${id}`
        return this.get(`/viewItens${params}`)
    }

    viewItensByPedidoIsLid(idsList){
        return this.post("/viewItensByPedidoIsLid", idsList)
    }

}

export default PedidoCompraService